import { render, staticRenderFns } from "./CommentsBlogs.vue?vue&type=template&id=5227cb78&scoped=true&"
import script from "./CommentsBlogs.vue?vue&type=script&lang=js&"
export * from "./CommentsBlogs.vue?vue&type=script&lang=js&"
import style0 from "./CommentsBlogs.vue?vue&type=style&index=0&id=5227cb78&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5227cb78",
  null
  
)

export default component.exports